import React, { Component } from 'react';
import { Modal, Radio, Input, Button, Spin, message } from 'antd';
import TableC from '../../basicElement/TableC';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import Text from '../../basicElement/Text';
import format from '../../shared/format';

const { Group: RadioGroup } = Radio;

class BaBatchTransfer extends Component {
    state = {
        data: {},
        record: {},
        visible: false,
        loading: false,
    }

    loadData = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.notice.queryBaHandOverById, { baHandOverById: this.relateId })
        .then(res => {
            this.setState({
                record: res.data || {},
                loading: false,
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    show = (approval, relateId) => {
        this.approval = approval;
        this.relateId = relateId;
        this.setState({ visible: true }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: {},
            record: {},
            visible: false,
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        switch(key) {
            case 'status':
                data.reason = undefined;
            default:
                data[key] = value;
        }
        this.setState({ data });
    }

    submit = () => {
        const { data } = this.state;
        const { status, reason } = data;
        if (!status) {
            message.warning('请选择交接确认！');
            return;
        } else if (status === 'DISAGREE' && !reason) {
            message.warning('请输入拒绝原因！');
            return;
        }

        this.setState({ loading: true });
        Fetch.post(API_URL.notice.handlerBaHandOverById, {
            ...data,
            baHandOverById: this.relateId,
        })
        .then(res => {
            message.success(res.success);
            this.setState({
                loading: false,
            }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    getColumns = () => {
        const columns = [{
            title: '交接BA',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 120,
            render: (text, record) => {
                const { employeeCode } = record;
                return format('joint', text, employeeCode);
            }
        }, {
            title: '接收BA',
            dataIndex: 'overUserName',
            key: 'overUserName',
            width: 120,
            render: (text, record) => {
                const { overEmployeeCode } = record;
                return format('joint', text, overEmployeeCode);
            }
        }, {
            title: '客户名称',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 240,
        }];
        return columns;
    }

    getContent = () => {
        const { record, data } = this.state;
        const { detailList, status: msgStatus } = record;
        const { status, reason } = data;
        return (
            <div>
                <TableC
                    scrollY={220}
                    data={detailList}
                    columns={this.getColumns()}
                    className="baHandOverDetailId"
                />
                {
                    msgStatus === 'NEW' && this.approval &&
                    <ul className="modal-list" style={{ marginTop: 20 }}>
                        <li className="modal-item" style={{ borderTop: '1px solid #f1f1f1' }}>
                            <div className="item-left" style={{ width: '15%', textAlign: 'left' }}><Text asterisk={false} colon={true}>交接确认</Text></div>
                            <div className="item-right" style={{ width: '85%' }}>
                                <RadioGroup onChange={e => this.handleChange(e.target.value, 'status')} value={status}>
                                    <Radio value='AGREE'>确认交接</Radio>
                                    <Radio value='DISAGREE'>拒绝交接</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                        {
                            status === 'DISAGREE' &&
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '15%' }}>&nbsp;</div>
                                <div className="item-right" style={{ width: '85%' }}>
                                    <Input
                                        maxLength="255"
                                        value={reason}
                                        placeholder="请填写拒绝原因"
                                        style={{width: 240}}
                                        onChange={e => this.handleChange(e.target.value, 'reason')}
                                    />
                                </div>
                            </li>
                        }
                    </ul>
                }
                {
                    msgStatus === 'DISAGREE' &&
                    <ul className="modal-list" style={{ marginTop: 20 }}>
                        <li className="modal-item" style={{ borderTop: '1px solid #f1f1f1' }}>
                            <div className="item-left" style={{ width: '15%', textAlign: 'left' }}><Text colon={true}>拒绝原因</Text></div>
                            <div className="item-right" style={{ width: '85%' }}>{record.reason}</div>
                        </li>
                    </ul>
                }
            </div>
        );
    }

    render() {
        const { visible, loading, record } = this.state;
        const setting = {};
        if (record.status !== 'NEW') {
            setting.footer = <Button type="ghost" onClick={this.hide}>关闭</Button>;
        }
        return (
            <Modal
                title="批量交接"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                confirmLoading={loading}
                maskClosable={false}
                width="560px"
                {...setting}
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: 0 }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default BaBatchTransfer;


// WEBPACK FOOTER //
// ./src/components/layout/notice/BaBatchTransfer.js